<div id="page-title">
  <div id="page-content" class="inicio" id="cobrancas-pix">
    <div class="row">
      <div class="col-sm-10 col-sm-offset-1">
        <div class="row" *ngIf="!error">
          <div class="container-datepicker col-xs-12">
            <app-datepicker [initialDate]="initialDateFilter" [finalDate]="finalDateFilter" (filter)="setFilterDate($event)"></app-datepicker>
          </div>
        </div>
        <div class="row" *ngIf="!error">
          <div class="col-sm-6">
            <div id="input-tag" class="input textarea caixa-pesquisa">
              <div>
                <input [(ngModel)]="inputSearch" (keyup)="filter()" class="input-searchbox" type="text" placeholder="Pesquisar">
              </div>
              <div class="filter-icon" (click)="toggleBox()"></div>
              <div [ngClass]="boxHidden ? 'box-hidden' : 'box-show'" class="box-filter">
                <div class="container-box-inner">
                  <label>Status</label>
                  <div *ngFor="let s of status">
                    <input (change)="changeTag($event, s.name)" id={{s.name}} type="checkbox" class="styled-checkbox" class="hidden">
                    <label for={{s.name}} *ngIf="!s.actived && cobrancasPixBkp && cobrancasPixBkp.length > 0 && hasStatusInCobrancasPix(s.name)">{{s.name}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <button (click)="emitirRelatorio()" class="btn btn-primary pull-right ml-2">Emitir relatório</button>
          </div>
        </div>
        <div *ngIf="!loaded && !error" class="container-loading">
          <div class="btn btn-registrar loading"></div>
        </div>
        <div class="col-md-10 col-md-offset-1" *ngIf="error">
          <span class="error">Nenhuma informação disponível no momento</span>
          <span class="error">Tente novamente mais tarde</span>
        </div>
       
        <table id="master-detail-table" style="width: 100%"></table>
      </div>
    </div>
  </div>
</div>
